import { useCallback } from 'react';

import { client } from 'core/http';
import { Slot } from 'core/types/slot';

export default function useSlotCreates() {
  return useCallback((axleId: number, position: number) => {
    return client()
      .post<Slot>(`axles/${axleId}/slots`, {
        axle_id: axleId,
        position
      })
      .then(response => response.data);
  }, []);
}
